/**
 * Centralized auth configuration.
 * Auth server URL sourced from runtime container configuration.
 */
import { appConfig } from "../config/runtime-config";

export const AUTH_CONFIG = {
  authServerUrl: appConfig.authServerUrl,
  clientId: "dashboard-spa",
  redirectUri: `${window.location.origin}/callback`,
  scopes: "openid profile email",
  endpoints: {
    authorize: "/oauth2/authorize",
    token: "/oauth2/token",
  },
};
